

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form18StatusInfoType } from '@/types/Information/Form18';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form18ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form18StatusInfoType;

}
